import { OmniTooltipNextComponent } from "../../../../../shared";
import OrderProgressCard from "./OrderProgressCard";
import ChannelPlanAlignment from "./ChannelPlanAlignment";
import TaxonomyComplianceCard from "./TaxonomyComplianceCard";
export default function PlanAlignmentCards({ planningSummary, channelsData, taxonomyCompliance,orderedData,isLocalCurrency }) {

    return (
        <div className="plan-alignment-cards">
            <div className="sectionWrapper plan-alignment-info-cards">
                <div className="left-section">
                    <OrderProgressCard {...planningSummary}  orderedData={orderedData} isLocalCurrency={isLocalCurrency}/>
                </div>
                <div className="left-section">
                    <ChannelPlanAlignment channelsData={channelsData} orderedData={orderedData} isLocalCurrency={isLocalCurrency} />
                </div>
                <div className="divder">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1" height="100" viewBox="0 0 1 100" fill="none">
                        <rect y="100" width="100" height="1" transform="rotate(-90 0 100)" fill="#CFD2D7"/>
                    </svg>
                </div>
                <div className="right-section">
                    <TaxonomyComplianceCard campaignData={taxonomyCompliance.campaignData} orderedData={orderedData} versionOneApi={taxonomyCompliance.versionOneApi} isLocalCurrency={isLocalCurrency} />
                </div>
            </div>
        </div>
    );
}
